import {Box} from "@mui/material";
import {RightDrawerProvider} from "crqlar-react-common/dist/components/header/RightDrawerContext";
import {Outlet} from "react-router-dom";
import DashboardSidebar from "./layout/leftSidebar/DashboardSidebar";
import MobileSidebar from "./layout/leftSidebar/MobileSidebar";
import {DASHBOARD_SIDEBAR_WIDTH} from "./layout/leftSidebar/sidebarLayout";
import {useCompactDashboardLayout} from "../utils/responsive.util";

const GenericLandingPage = () => {
    const isCompactLayout = useCompactDashboardLayout();

    return (
        <RightDrawerProvider>
            <Box className="App">
                <Box sx={{display: isCompactLayout ? "none" : "block"}}>
                    <DashboardSidebar/>
                </Box>

                <MobileSidebar>
                    <Box
                        sx={{
                            marginLeft: isCompactLayout ? 0 : `${DASHBOARD_SIDEBAR_WIDTH}px`,
                            display: "flex",
                            flexDirection: "row",
                            boxSizing: "border-box",
                            "@media print": {marginLeft: 0},
                        }}
                    >
                        <Outlet/>
                    </Box>
                </MobileSidebar>
            </Box>
        </RightDrawerProvider>
    );
};

export default GenericLandingPage;
